/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElForm as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElDatePicker as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/date-picker/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
import { apiUsdkSaveRealNameConfig, apiUsdkUpdateRealNameConfig } from '@/api/usdk';
import dayjs from 'dayjs';
import { useGlobalStateStore } from '@/store/modules/globalState';
export default /*#__PURE__*/_defineComponent({
  __name: 'addOrEditParamsRealName',
  props: {
    gid: {
      type: Number
    }
  },
  emits: ['success'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const {
      getNotice
    } = useGlobalStateStore();
    const dialogVisible = ref(false);
    const type = ref('add');
    const confirmLoading = ref(false);
    const formData = ref({
      appId: '',
      secretKey: '',
      filingCode: '',
      startTime: new Date(),
      invalidTime: new Date()
    });
    const formRef = ref();
    const disabledDate = computed(() => {
      // 获取当前日期
      const today = new Date();
      // 将时、分、秒、毫秒都设置为0，只保留日期部分
      // 禁用未来的日期
      return time => time.getTime() > today.getTime();
    });
    const props = __props;
    const emits = __emit;
    const handleClose = formEl => {
      dialogVisible.value = false;
      formEl.resetFields();
      formData.value = {
        appId: '',
        secretKey: '',
        filingCode: '',
        startTime: new Date(),
        invalidTime: new Date()
      };
    };
    const validatorInvalidTime = (rule, value, callback) => {
      if (formData.value.invalidTime && formData.value.startTime) {
        if (dayjs(formData.value.invalidTime).valueOf() < dayjs(formData.value.startTime).valueOf()) {
          callback(new Error('失效时间不能小于生效时间'));
        }
      } else if (!formData.value.invalidTime) {
        callback(new Error('请选择失效时间'));
      } else {
        callback(new Error('请选择生效时间'));
      }
      callback();
    };
    const handleOk = () => {
      var _formRef$value;
      (_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.validate(valid => {
        if (valid) {
          console.log('formData.value', formData.value);
          confirmLoading.value = true;
          let api = type.value === 'add' ? apiUsdkSaveRealNameConfig : apiUsdkUpdateRealNameConfig;
          api({
            gid: props.gid,
            ...formData.value,
            startTime: dayjs(formData.value.startTime).valueOf(),
            invalidTime: dayjs(formData.value.invalidTime).valueOf()
          }).then(res => {
            if (res.code === 0) {
              emits('success');
              handleClose(formRef.value);
              getNotice(props.gid);
            }
          }).finally(() => {
            confirmLoading.value = false;
          });
        }
      });
    };
    const show = payload => {
      dialogVisible.value = true;
      type.value = payload.type;
      if (payload.data) {
        formData.value = JSON.parse(JSON.stringify(payload.data));
        formData.value.startTime = payload.data.startTime ? new Date(Number(payload.data.startTime)) : '';
        formData.value.invalidTime = payload.data.invalidTime ? new Date(Number(payload.data.invalidTime)) : '';
      }
    };
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_input = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_date_picker = __unplugin_components_2;
      const _component_el_form = __unplugin_components_3;
      const _component_el_button = __unplugin_components_4;
      const _component_el_dialog = __unplugin_components_5;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: `${_unref(type) === 'add' ? '新增' : '编辑'}实名参数`,
        width: "500px",
        "before-close": () => handleClose(_unref(formRef))
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = $event => handleClose(_unref(formRef)))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleOk
        }, {
          default: _withCtx(() => [_createTextVNode("确定 ")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: _unref(formData),
          "label-width": "100px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "AppId",
            prop: "appId",
            rules: [{
              required: true,
              message: '请输入AppID',
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(formData).appId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(formData).appId = $event),
              placeholder: "请输入AppID"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "Secret Key",
            prop: "secretKey",
            rules: [{
              required: true,
              message: '请输入Secret Key',
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(formData).secretKey,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(formData).secretKey = $event),
              placeholder: "请输入Secret Key"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "备案识别码",
            prop: "filingCode",
            rules: [{
              required: true,
              message: '请输入备案识别码',
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(formData).filingCode,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(formData).filingCode = $event),
              placeholder: "请输入备案识别码"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "生效时间",
            prop: "startTime",
            rules: [{
              validator: validatorInvalidTime
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: _unref(formData).startTime,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(formData).startTime = $event),
              type: "datetime",
              placeholder: "选择生效时间",
              disabledDate: _unref(disabledDate),
              format: "YYYY-MM-DD HH:mm:ss",
              "value-format": "x"
            }, null, 8, ["modelValue", "disabledDate"])]),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_el_form_item, {
            label: "失效时间",
            prop: "invalidTime",
            rules: [{
              validator: validatorInvalidTime
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: _unref(formData).invalidTime,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(formData).invalidTime = $event),
              type: "datetime",
              placeholder: "选择失效时间",
              format: "YYYY-MM-DD HH:mm:ss",
              "value-format": "x"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["rules"])]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue", "title", "before-close"]);
    };
  }
});